import { useCallback, useEffect, useState } from "react";
import { format } from "date-fns";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";

const DEFAULT_SUMMARY = {
  conversations: { current: 0, previous: 0, delta_pct: null },
  queries: { current: 0, previous: 0, delta_pct: null },
  voice_queries: { current: 0, previous: 0, delta_pct: null },
  avg_chat_length: { current: 0, previous: 0, delta_pct: null },
  assistants_count: 0,
};

export default function useSummary({ dateRange }) {
  const baseUrl = getHostDomain();
  const [summary, setSummary] = useState(DEFAULT_SUMMARY);
  const [status, setStatus] = useState("loading");

  const fetch = useCallback(async () => {
    if (!dateRange?.startDate || !dateRange?.endDate) return;
    setStatus("loading");
    try {
      const from = format(dateRange.startDate, "yyyy-MM-dd");
      const to = format(dateRange.endDate, "yyyy-MM-dd");
      const res = await fetchController(
        `${baseUrl}/api/v1/analytics/summary?date_from=${from}&date_to=${to}`,
        "GET"
      );
      setSummary(res || DEFAULT_SUMMARY);
    } catch {
      setSummary(DEFAULT_SUMMARY);
    } finally {
      setStatus("idle");
    }
  }, [baseUrl, dateRange?.startDate, dateRange?.endDate]);

  useEffect(() => { fetch(); }, [fetch]);

  return { summary, status };
}
